import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import './LoginPage.css';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    if (isLoading) return;
    setError('');
    setIsLoading(true);
    try {
      const response = await api.post('/auth/login', { email, password });

      if (response.data.token && response.data.userType) {
        const userType = response.data.userType;

        if (userType === 'ADMIN') {
          localStorage.setItem('adminToken', response.data.token);
          localStorage.setItem('adminUser', JSON.stringify({ userType }));
          navigate('/dashboard');
        } else {
          setError('Access denied. You must be an administrator to log in here.');
        }
      } else {
        setError('Invalid response from server. Please try again.');
      }
    } catch (err) {
      console.error('Login error:', err);
      setError('Invalid credentials or server error');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="admin-login-page">
      <video className="admin-login-video" autoPlay loop muted playsInline>
        <source src="/Loginvid.mp4" type="video/mp4" />
      </video>

      <div className="admin-login-overlay">
        <div className="admin-login-card">
          <img src="/eduLogo.png" alt="Eduthrift Logo" className="admin-login-logo" />
          <h2>Admin Login</h2>
          {error && <p className="admin-login-error">{error}</p>}
          <form onSubmit={handleLogin}>
            <div className="admin-form-group">
              <label>Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="admin-form-group">
              <label>Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            <button type="submit" disabled={isLoading}>
              {isLoading ? 'Logging in...' : 'Login'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
